import { render, staticRenderFns } from "./discout_detail.vue?vue&type=template&id=67d542a6&scoped=true&"
import script from "./discout_detail.vue?vue&type=script&lang=js&"
export * from "./discout_detail.vue?vue&type=script&lang=js&"
import style0 from "./discout_detail.vue?vue&type=style&index=0&id=67d542a6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d542a6",
  null
  
)

export default component.exports